import React from 'react';
import { ModalHeader, Sym } from './ui.jsx';

const Modal = ({ tone, icon, title, subtitle, onClose, children }) => (
  <div className="modal-bg" onClick={onClose} role="dialog" aria-modal="true" aria-label={title}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-head">
        <ModalHeader tone={tone} icon={icon} title={title} subtitle={subtitle} />
        <button type="button" className="glass-pill round" onClick={onClose} aria-label="Close"><Sym name="close" size={20} /></button>
      </div>
      <div className="modal-body">{children}</div>
    </div>
  </div>
);

// Privacy + Terms share the same data-driven renderer (sections with intro/body/items).
export const LegalModal = ({ doc, tone, icon, onClose }) => (
  <Modal tone={tone} icon={icon} title={doc.title} subtitle={doc.lastUpdated} onClose={onClose}>
    {doc.contact && <p className="meta">{doc.contact}</p>}
    <p>{doc.intro}</p>
    {doc.sections.map((s) => (
      <section key={s.title}>
        <h3>{s.title}</h3>
        {s.intro && <p>{s.intro}</p>}
        {s.body && <p>{s.body}</p>}
        {s.items?.length > 0 && <ul>{s.items.map((it) => <li key={it}>{it}</li>)}</ul>}
      </section>
    ))}
  </Modal>
);
